function t(r, ...c) {
  return c.reduce(
    (e, n) => (e[n] = r[n], e),
    {}
  );
}
export {
  t as p
};
